module.exports = __webpack_public_path__ + "img/00039.905bc881.webp";